module.exports = __webpack_public_path__ + "static/img/lhra.904b564.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/lhra.png
// module id = 4rwe
// module chunks = 0